import React from 'react';
import {Link} from 'react-router-dom';
import {
    Button,
    Container,
    Divider,
    Group,
    List,
    Paper,
    SimpleGrid,
    Stack,
    Text,
    ThemeIcon,
    Title,
    useMantineTheme
} from '@mantine/core';
import {useConfig} from '../ConfigContext';

/**
 * Consulting sits beside the portfolio rather than inside it: these are
 * engagements, not products, so they get a flat grid instead of the venture
 * card treatment used on /ventures.
 */
function Consulting() {
    const theme = useMantineTheme();
    const {consulting} = useConfig();

    return (
        <Container size="xl" py="xl">
            <Stack gap={56}>
                <Stack gap="sm">
                    <Title order={1} c={theme.colors.brand[6]}>{consulting.heading}</Title>
                    <Text size="lg" maw={820}>{consulting.intro}</Text>
                </Stack>

                <SimpleGrid cols={{base: 1, sm: 2, lg: 3}} spacing="lg">
                    {consulting.offerings.map((offering) => (
                        <Paper key={offering.title} withBorder radius="lg" p="lg" shadow="sm" h="100%">
                            <Stack gap="md">
                                <ThemeIcon variant="light" color="brand" size={52} radius="xl">
                                    {React.createElement(offering.icon, {
                                        size: 28,
                                        stroke: 1.5,
                                        color: theme.colors.brand[6]
                                    })}
                                </ThemeIcon>
                                <Text fw={700} size="lg">{offering.title}</Text>
                                <List spacing={4} size="sm">
                                    {offering.valuePoints.map((point) => (
                                        <List.Item key={point}>{point}</List.Item>
                                    ))}
                                </List>
                                <Text size="sm" c="dimmed">{offering.description}</Text>
                            </Stack>
                        </Paper>
                    ))}
                </SimpleGrid>

                <Divider/>

                <Stack gap="md" maw={820}>
                    <Title order={2} size="h3">Not sure which one you need?</Title>
                    <Text>
                        Tell us what the work actually looks like. If one of our ventures already
                        solves it, we will point you there instead — that is usually faster and
                        cheaper than an engagement.
                    </Text>
                    <Group mt="xs">
                        <Button component={Link} to="/contact-us" radius="xl" color="brand.6">
                            Talk to us
                        </Button>
                        <Button component={Link} to="/ventures" radius="xl" variant="light" color="brand">
                            See the ventures
                        </Button>
                    </Group>
                </Stack>
            </Stack>
        </Container>
    );
}

export default Consulting;
